import * as Sentry from '@sentry/vue'

const isDev = process.env.NODE_ENV !== 'production'

// In production, logger.error still needs to be visible — send it to Sentry.
// Finds the first Error-like argument (preserves stack traces) and treats the
// rest as context. Falls back to captureMessage when there's no Error.
const reportError = (args) => {
  const errorArg = args.find(a => a instanceof Error)
  const context = args.filter(a => !(a instanceof Error))
  const message = context.map(a => typeof a === 'string' ? a : safeStringify(a)).join(' ') || 'logger.error'

  if (errorArg) {
    Sentry.captureException(errorArg, { extra: { message } })
  } else {
    Sentry.captureMessage(message, 'error')
  }
}

const safeStringify = (v) => {
  try { return JSON.stringify(v) } catch { return String(v) }
}

export const logger = {
  log: (...args) => { if (isDev) console.log(...args) },
  warn: (...args) => { if (isDev) console.warn(...args) },
  error: (...args) => {
    if (isDev) {
      console.error(...args)
    } else {
      reportError(args)
    }
  },
  debug: (...args) => { if (isDev) console.debug(...args) },
}
